import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api/tools`,
});

api.interceptors.request.use((config) => {
  // Generate anonymous ID if not exists
  if (!localStorage.getItem('userAnonId')) {
    localStorage.setItem('userAnonId', crypto.randomUUID());
  }
  config.headers['x-user-anon-id'] = localStorage.getItem('userAnonId');

  // Set JWT Bearer token if available
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  return config;
}, (error) => {
  return Promise.reject(error);
});

// Handle 401 responses globally — clear stale tokens
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('userProfileData');
      localStorage.removeItem('creditBalance');
    }
    return Promise.reject(error);
  }
);

export default api;
